import { render, staticRenderFns } from "./DecisionView.vue?vue&type=template&id=810c35a4&scoped=true&"
import script from "./DecisionView.vue?vue&type=script&lang=ts&"
export * from "./DecisionView.vue?vue&type=script&lang=ts&"
import style0 from "./DecisionView.vue?vue&type=style&index=0&id=810c35a4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810c35a4",
  null
  
)

export default component.exports